export default function BrandIntro() {
  return (
    <section id="brand" className="w-full px-4 md:px-6 py-16 md:py-20">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="font-heading text-3xl md:text-5xl text-foreground-900 mb-6">
            关于重生萝莉岛
          </h1>
          <p className="text-foreground-600 text-lg leading-relaxed max-w-2xl mx-auto">
            以神秘岛屿为背景的重生冒险题材内容平台
          </p>
        </div>

        <div className="relative h-[300px] md:h-[400px] rounded-2xl overflow-hidden mb-12">
          <img
            src="https://readdy.ai/api/search-image?query=Anime%20style%20beautiful%20fantasy%20floating%20island%20with%20colorful%20aurora%20sky%2C%20cute%20chibi%20characters%20waving%20from%20the%20island%2C%20magical%20crystals%20floating%20around%2C%20warm%20inviting%20atmosphere%2C%20soft%20pastel%20colors%2C%20dreamy%20lighting&width=1200&height=600&seq=about-brand-hero&orientation=landscape"
            alt="重生萝莉岛品牌形象"
            title="重生萝莉岛——萌系重生奇幻岛屿"
            className="w-full h-full object-cover"
          />
        </div>

        <div className="space-y-6 text-foreground-700 leading-relaxed">
          <p>
            <strong className="text-foreground-900">重生萝莉岛</strong>成立于2024年，是一个专注于重生冒险题材的综合性内容平台。我们汇聚了来自全国各地的资深玩家和内容创作者，致力于为所有热爱重生萝莉岛的冒险者提供最全面、最专业、最及时的内容服务。
          </p>
          <p>
            我们的团队由一群热爱二次元文化、痴迷于奇幻世界观的创作者组成。从攻略编写到剧情解析，从角色图鉴到世界观考据，每一位团队成员都倾注了无限的创意。我们相信，<strong className="text-foreground-900">重生萝莉岛</strong>不仅仅是一个内容平台，更是一个让冒险者们相聚、交流、共同成长的温暖社区。
          </p>
          <p>
            在重生萝莉岛上，每一次重生都意味着新的开始。这不仅是游戏的核心理念，也是我们团队的信念——无论遇到什么困难，我们都会像游戏中的冒险者一样，不断重生、不断进步，为大家带来更好的内容体验。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-12">
          {[
            { icon: 'ri-article-line', label: '原创文章', value: '200+' },
            { icon: 'ri-user-star-line', label: '活跃用户', value: '50,000+' },
            { icon: 'ri-heart-line', label: '社区互动', value: '100,000+' },
          ].map((stat) => (
            <div key={stat.label} className="text-center p-6 bg-background-100 rounded-xl">
              <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center">
                <i className={`${stat.icon} text-2xl text-accent-500`}></i>
              </div>
              <div className="font-heading text-2xl md:text-3xl text-foreground-900 mb-1">{stat.value}</div>
              <div className="text-sm text-foreground-600">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}